declare namespace $ {

	type __shm_hitalama_map_book_widgets3_1 = $mol_type_enforce<
		Parameters< $shm_hitalama_map_book_widgets3['go_to_widget'] >[0]
		,
		Parameters< ReturnType< $shm_hitalama_map_book_widgets3['Map_page'] >['go_to_widget'] >[0]
	>
	type $mol_button_minor__sub_shm_hitalama_map_book_widgets3_2 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $shm_hitalama_map_page_contextmenu__Map_page_shm_hitalama_map_book_widgets3_3 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_book_widgets3['Map_page'] >
		,
		ReturnType< $shm_hitalama_map_page_contextmenu['Map_page'] >
	>
	type $shm_hitalama_map_page_contextmenu__contextmenu_real_pos_shm_hitalama_map_book_widgets3_4 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $shm_hitalama_map_page_contextmenu['contextmenu_real_pos'] >
	>
	type $shm_hitalama_map_page_contextmenu__widget_add_shm_hitalama_map_book_widgets3_5 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_book_widgets3['widget_add'] >
		,
		ReturnType< $shm_hitalama_map_page_contextmenu['widget_add'] >
	>
	type $mol_pop_over__align_shm_hitalama_map_book_widgets3_6 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_pop_over['align'] >
	>
	type $mol_pop_over__Anchor_shm_hitalama_map_book_widgets3_7 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_book_widgets3['Add_widget_anchor'] >
		,
		ReturnType< $mol_pop_over['Anchor'] >
	>
	type $mol_pop_over__bubble_content_shm_hitalama_map_book_widgets3_8 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_pop_over['bubble_content'] >
	>
	type $mol_check_box__title_shm_hitalama_map_book_widgets3_9 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check_box['title'] >
	>
	type $mol_check_box__checked_shm_hitalama_map_book_widgets3_10 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_book_widgets3['show_removed'] >
		,
		ReturnType< $mol_check_box['checked'] >
	>
	type $shm_list_head__title_shm_hitalama_map_book_widgets3_11 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_book_widgets3['title'] >
		,
		ReturnType< $shm_list_head['title'] >
	>
	type $shm_list_head__filter_shm_hitalama_map_book_widgets3_12 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_book_widgets3['filter'] >
		,
		ReturnType< $shm_list_head['filter'] >
	>
	type $shm_list_head__add_content_shm_hitalama_map_book_widgets3_13 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $shm_list_head['add_content'] >
	>
	type $shm_list_head__filter_content_shm_hitalama_map_book_widgets3_14 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $shm_list_head['filter_content'] >
	>
	type $shm_list_head__close_shm_hitalama_map_book_widgets3_15 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_book_widgets3['close_widgets_list'] >
		,
		ReturnType< $shm_list_head['close'] >
	>
	type $mol_view__sub_shm_hitalama_map_book_widgets3_16 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_book_widgets3['widget_title_content'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_hitalama_map_book_widgets3_17 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__attr_shm_hitalama_map_book_widgets3_18 = $mol_type_enforce<
		({ 
			'selected': ReturnType< $shm_hitalama_map_book_widgets3['widget_selected'] >,
		})  & ReturnType< $mol_view['attr'] >
		,
		ReturnType< $mol_view['attr'] >
	>
	type $shm_hitalama_dragtree__roots_shm_hitalama_map_book_widgets3_19 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_book_widgets3['tree_roots'] >
		,
		ReturnType< $shm_hitalama_dragtree['roots'] >
	>
	type $shm_hitalama_dragtree__children_shm_hitalama_map_book_widgets3_20 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_book_widgets3['tree_children'] >
		,
		ReturnType< $shm_hitalama_dragtree['children'] >
	>
	type $shm_hitalama_dragtree__expanded_shm_hitalama_map_book_widgets3_21 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_book_widgets3['widget_expanded'] >
		,
		ReturnType< $shm_hitalama_dragtree['expanded'] >
	>
	type $shm_hitalama_dragtree__can_have_children_shm_hitalama_map_book_widgets3_22 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_book_widgets3['can_have_children'] >
		,
		ReturnType< $shm_hitalama_dragtree['can_have_children'] >
	>
	type $shm_hitalama_dragtree__Item_shm_hitalama_map_book_widgets3_23 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_book_widgets3['Widget_item'] >
		,
		ReturnType< $shm_hitalama_dragtree['Item'] >
	>
	type $mol_list__rows_shm_hitalama_map_book_widgets3_24 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_book_widgets3['removed_widget_rows'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_view__sub_shm_hitalama_map_book_widgets3_25 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_hitalama_map_book_widgets3_26 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_minor__title_shm_hitalama_map_book_widgets3_27 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_hitalama_map_book_widgets3_28 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_book_widgets3['widget_restore'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_view__sub_shm_hitalama_map_book_widgets3_29 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_link__sub_shm_hitalama_map_book_widgets3_30 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_link['sub'] >
	>
	type $mol_link__uri_shm_hitalama_map_book_widgets3_31 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_book_widgets3['edit_widget_uri'] >
		,
		ReturnType< $mol_link['uri'] >
	>
	type $mol_link__event_shm_hitalama_map_book_widgets3_32 = $mol_type_enforce<
		({ 
			dragstart( next?: ReturnType< $shm_hitalama_map_book_widgets3['widget_link_dragstart'] > ): ReturnType< $shm_hitalama_map_book_widgets3['widget_link_dragstart'] >,
		})  & ReturnType< $mol_link['event'] >
		,
		ReturnType< $mol_link['event'] >
	>
	type $mol_view__sub_shm_hitalama_map_book_widgets3_33 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_minor__sub_shm_hitalama_map_book_widgets3_34 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_minor__click_shm_hitalama_map_book_widgets3_35 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_book_widgets3['widget_click'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__clicks_shm_hitalama_map_book_widgets3_36 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_book_widgets3['widget_rename_start'] >
		,
		ReturnType< $mol_button_minor['clicks'] >
	>
	type $mol_string__value_shm_hitalama_map_book_widgets3_37 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_book_widgets3['widget_title_draft'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_string__submit_shm_hitalama_map_book_widgets3_38 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_book_widgets3['widget_rename_submit'] >
		,
		ReturnType< $mol_string['submit'] >
	>
	type $mol_string__event_shm_hitalama_map_book_widgets3_39 = $mol_type_enforce<
		({ 
			pointerdown( next?: ReturnType< $shm_hitalama_map_book_widgets3['widget_rename_pointerdown'] > ): ReturnType< $shm_hitalama_map_book_widgets3['widget_rename_pointerdown'] >,
			blur( next?: ReturnType< $shm_hitalama_map_book_widgets3['widget_rename_submit'] > ): ReturnType< $shm_hitalama_map_book_widgets3['widget_rename_submit'] >,
			keydown( next?: ReturnType< $shm_hitalama_map_book_widgets3['widget_rename_keydown'] > ): ReturnType< $shm_hitalama_map_book_widgets3['widget_rename_keydown'] >,
		})  & ReturnType< $mol_string['event'] >
		,
		ReturnType< $mol_string['event'] >
	>
	type $mol_view__attr_shm_hitalama_map_book_widgets3_40 = $mol_type_enforce<
		({ 
			'removed': boolean,
		})  & ReturnType< $mol_view['attr'] >
		,
		ReturnType< $mol_view['attr'] >
	>
	type $mol_view__sub_shm_hitalama_map_book_widgets3_41 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_hitalama_map_book_widgets3_42 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $shm_hitalama_map_book_widgets3 extends $mol_page {
		go_to_widget( id: any): ReturnType< ReturnType< $shm_hitalama_map_book_widgets3['Map_page'] >['go_to_widget'] >
		filter( next?: string ): string
		Add_widget_icon( ): $mol_icon_plus
		Add_widget_anchor( ): $mol_button_minor
		widget_add( id: any): any
		Add_widget_menu( ): $shm_hitalama_map_page_contextmenu
		Add_widget( ): $mol_pop_over
		show_removed( next?: boolean ): boolean
		Show_removed( ): $mol_check_box
		close_widgets_list( next?: any ): any
		Head( ): $shm_list_head
		tree_roots( next?: readonly(any)[] ): readonly(any)[]
		tree_children( id: any, next?: readonly(any)[] ): readonly(any)[]
		widget_expanded( id: any, next?: boolean ): boolean
		can_have_children( id: any): boolean
		widget_title_content( id: any): readonly(any)[]
		Widget_title( id: any): $mol_view
		widget_selected( id: any): boolean
		Widget_item( id: any): $mol_view
		Tree( ): $shm_hitalama_dragtree
		removed_widget_rows( ): readonly(any)[]
		Removed_widgets( ): $mol_list
		removed_widgets_visible( ): readonly(any)[]
		Widget_icon( id: any): $mol_icon_square_outline
		widget_title( id: any): string
		Widget_title_text( id: any): $mol_view
		widget_click( id: any, next?: any ): any
		widget_rename_start( id: any, next?: any ): any
		widget_title_draft( id: any, next?: string ): string
		widget_rename_submit( id: any, next?: any ): any
		widget_rename_pointerdown( id: any, next?: any ): any
		widget_rename_keydown( id: any, next?: any ): any
		Removed_widget_title( id: any): $mol_view
		widget_restore( id: any, next?: any ): any
		Widget_restore( id: any): $mol_button_minor
		Removed_widget_line( id: any): $mol_view
		edit_widget_uri( id: any): string
		widget_link_dragstart( id: any, next?: any ): any
		Widget_link( id: any): $mol_link
		Editor_widget_line( id: any): $mol_view
		map( ): $shm_hitalama_map
		Map_page( ): $shm_hitalama_map_page
		editor_mode_enabled( ): boolean
		widget_list_visible( next?: boolean ): boolean
		title( ): string
		head( ): readonly(any)[]
		body( ): readonly(any)[]
		Widget_title_button( id: any): $mol_button_minor
		Widget_title_input( id: any): $mol_string
		Removed_widget_item( id: any): $mol_view
		Editor_widget_item( id: any): $mol_view
	}
	
}

//# sourceMappingURL=widgets3.view.tree.d.ts.map